module.exports = __webpack_public_path__ + "static/media/3.fbb4cad0.png";